import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation } from 'react-router-dom';
import StockGrid from './stockGrid';
import { toast } from 'react-toastify';
import ApiService from '../../../INVENTORY/services/apiService'
import { hasPermission } from "../../services/roleService"
import { RiRefreshLine } from "react-icons/ri";
import { FaSave } from "react-icons/fa";
import Pagination from '../pagination/pagination';
import { PropagateLoader } from 'react-spinners';
import { GrEdit } from "react-icons/gr";

const StockMaster = () => {
    let navigate = useNavigate();
    const location = useLocation();
    const [rowData, setRowData] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [selectedRow, setSelectedRow] = useState(null);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        recordId: "",
        stockTypeCode: "",
        stockTypeName: "",
    });

    useEffect(() => {
        getItems();
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        setPermissions(storedPermissions);
    }, []);


    const checkPermission = (moduleName, action) => {
        return hasPermission(moduleName, action, permissions);
    };
    // const canEditMaster = checkPermission('Stock Master', 'edit');
    // const canCreateMaster = checkPermission('Stock Master', 'create');
    const canEditMaster = true;
    const canCreateMaster = true;
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleSubmit = async () => {
        if (!formData.stockTypeCode || !formData.stockTypeName) {
            if (!formData.stockTypeName) { toast.warning("Enter Stock Type Name") }
            if (!formData.stockTypeCode) { toast.warning("Enter Stock Type Code") }
            return;
        }
        try {
            const apiService = new ApiService()
            let data = {
                stockTypeCode: formData?.stockTypeCode,
                stockTypeName: formData?.stockTypeName,
                active: 1,
            }
            const response = await apiService.post('CREATE_STOCK_TYPE', data);

            if (response?.data?.statusCode === 201 || 200) {
                getItems()
                toast.success(response?.data?.message)
                setFormData({
                    stockTypeCode: "",
                    stockTypeName: "",
                });

            } else if (response?.data?.statusCode === 208) {
                toast?.warning(response?.data?.message)
                setFormData({
                    stockTypeCode: "",
                    stockTypeName: "",
                });
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        }
    };
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            const res = await apiService.getApiParamater('GET_STOCK_TYPE', `?${params.toString()}`);
            setPagination(res.data.paginationData);
            setRowData(res?.data?.result || []);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    };
    const updateFormData = async () => {
        try {
            const apiService = new ApiService();
            let body = {
                recordId: formData?.recordId,
                stockTypeName: formData?.stockTypeName,
                stockTypeCode: formData?.stockTypeCode,
            }
            const response = await apiService.put(`UPDATE_STOCK_TYPE`, body);

            if (response?.data?.statusCode === 201) {
                toast.success(response?.data?.message);
                setFormData({
                    recordId: "",
                    stockTypeCode: "",
                    stockTypeName: "",
                })
                setSelectedRow(null)
                window.history.replaceState({}, '')
                getItems()
            } else {
                toast.error(response?.data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
            console.error('Error updating form data:', error);
        }
    };
    const handleEdit = (clickedRowData) => {
        if (clickedRowData || selectedRow) {
            setFormData({
                recordId: clickedRowData?.recordid || selectedRow?.recordid,
                stockTypeName: clickedRowData?.stockTypeName || selectedRow?.stockTypeName || "",
                stockTypeCode: clickedRowData?.stockTypeCode || selectedRow?.stockTypeCode || "",
            });
        }
    };
    const handleClearFilters = () => {
        setFormData({
            recordId: "",
            stockTypeCode: "",
            stockTypeName: "",
        })
        setSelectedRow(null)
        getItems()
    };
    return (
        <div className='px-4 pt-3'>
           
            <div className='py-lg-3'>
                <div className='gridBg p-3' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='d-flex justify-contant-between mb-4'>
                <h5 className='col mainInvHead'>Stock Type Master</h5>
                <div className='d-flex justify-content-end gap-1'>
                    <div
                        onClick={handleEdit}
                        className={`mainbtnSecondary flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
                        style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
                    >
                        <GrEdit color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Edit</div>
                    </div>
                    <div className='col center'>
                        {selectedRow ? (
                            <button className='mainbtn ' onClick={updateFormData}><FaSave className='center mt-1 mx-2' /> <div>Update</div></button>
                        ) : (
                            <>{canCreateMaster === true ?
                                <button className='mainbtn ' type="submit" onClick={() => handleSubmit()}>
                                    <FaSave className='center mt-1 mx-2' /> <div>Save</div></button>
                                :
                                <button className='mainbtn ' type="submit" style={{ cursor: "not-allowed" }}>
                                    <FaSave className='center mt-1 mx-2' /> <div>Save</div></button>
                            } </>
                        )}
                    </div>
                    <button className='mainbtnRed' onClick={handleClearFilters}><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>
                </div>
            </div>
                    <div className="form-group row">
                        <div className="col d-flex justify-content-between">
                            <label htmlFor="validationCustom01" className="form-label  pt-2 start">Stock Type Code *</label>
                            <input
                                type="text"
                                className="form-Input w-70"
                                id="validationCustom01"
                                disabled={canCreateMaster === true ? false : true}
                                name="stockTypeCode"
                                value={formData.stockTypeCode}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="col d-flex justify-content-between">
                            <label htmlFor="validationCustom01" className="form-label  pt-2 start">Stock Type Name *</label>
                            <input
                                type="text"
                                className="form-Input w-70"
                                id="validationCustom01"
                                name="stockTypeName"
                                disabled={canCreateMaster === true ? false : true}
                                value={formData.stockTypeName}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='gridBg mt-3'>
                {loading ? (
                    <div className='center'>
                        <PropagateLoader color="#6E5199" size={15} />
                    </div>
                ) : (
                    <>
                        <StockGrid rowData={rowData} getItems={getItems} loading={loading} handleEdit={handleEdit}
                            setSelectedRow={setSelectedRow} canEditMaster={canEditMaster} />
                        <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
                    </>
                )}
            </div>
        </div>
    )
}
export default StockMaster;
